import EditIcon from "@material-ui/icons/Create";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandlessIcon from "@material-ui/icons/ExpandLess";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import React, { Component } from "react";
import ButtonMenu from "../ButtonMenu";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { IconButton } from "@material-ui/core";
import Question from "@material-ui/icons/Help";
import Answer from "@material-ui/icons/Comment";
import Decision from "@material-ui/icons/Beenhere";
import View from "@material-ui/icons/Visibility";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "@material-ui/core/Select";
import { withTranslation } from "react-i18next";

// import { DragSource, DropTarget } from 'react-dnd';
const styles = (theme) => ({
  viewNotes: {
    color: theme.palette.secondary.main,
  },
  test: {},
});

// const itemSource = {
// 	beginDrag(props) {
// 		return props.node;
// 	},
// 	endDrag(props, monitor, component) {
// 		if (!monitor.didDrop()) {
// 			return;
// 		} else {
// 			return props.handleDrop(props.node);
// 		}
// 	}
// }
// function collect(connect, monitor) {
// 	return {
// 		connectDragSource: connect.dragSource(),
// 		connectDragPreview: connect.dragPreview(),
// 		isDragging: monitor.isDragging(),
// 	}
// }
// function targetCollect(connect, monitor) {
// 	return {
// 		connectDropTarget: connect.dropTarget(),
// 		isOver: monitor.isOver(),
// 		dropItem: monitor.getItem(),
// 	}
// }
// const targetSpec = {
// 	drop(props, monitor, component) {
// 		console.log(props.node);
// 		return props.node;
// 	},
// 	hover(props, monitor, component) {
// 		console.log(" overing over" + props.node.number)
// 	}
// }
class TreeNode extends Component {
  render() {
    // const ChildNode = withStyles(styles)(DragSource('node', itemSource, collect)(DropTarget('node', targetSpec, targetCollect)(TreeNode)));
    const {
      classes,
      isDragging,
      connectDragSource,
      item,
      connectDropTarget,
      hovered,
      dropItem,
      t,
    } = this.props;
    let space = 48 * this.props.count;
    // const opacity = isDragging ? 0 : 1;
    // return connectDropTarget(connectDragSource(
    return (
      <div aria-label="Node" data-title={this.props.node.label}>
        <ListItem disableGutters>
          <div style={{ height: "48px", width: space + "px" }} />
          {this.props.node.children.length > 0 ? (
            this.state.open ? (
              <Tooltip title={"Expand"} aria-label={"Expand"}>
                <IconButton onClick={this.expand}>
                  <ExpandMoreIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title={"Collapse"} aria-label={"Collapse"}>
                <IconButton onClick={this.expand}>
                  <ExpandlessIcon />
                </IconButton>
              </Tooltip>
            )
          ) : this.props.count > 0 ? (
            <div style={{ height: "48px", width: "48px" }} />
          ) : null}
          {this.props.node.type !== "root" ? (
            this.props.node.type === "question" ||
            this.props.node.type === "decision" ? (
              <Select
                aria-label="Change type"
                arrowrenderer={null}
                label="Node type"
                disableUnderline
                style={{ color: "rgba(0, 0, 0, 0.54)" }}
                value={this.props.node.type}
                onChange={(value) =>
                  this.props.changeType(this.props.node, value)
                }
              >
                <MenuItem
                  style={{ color: "rgba(0, 0, 0, 0.54)" }}
                  value={"question"}
                >
                  <Tooltip title={"Question"} aria-label={"Question"}>
                    <Question />
                  </Tooltip>
                </MenuItem>
                {this.props.node.number != 2 && (
                  <MenuItem
                    style={{ color: "rgba(0, 0, 0, 0.54)" }}
                    value={"decision"}
                  >
                    <Tooltip title={"Decision"} aria-label={"Decision"}>
                      <Decision />
                    </Tooltip>
                  </MenuItem>
                )}
              </Select>
            ) : (
              <ListItemIcon>
                <Tooltip title={"Answer"} aria-label={"Answer"}>
                  <Answer />
                </Tooltip>
              </ListItemIcon>
            )
          ) : null}
          {this.props.node.type !== "root" ? (
            <TextField
              required
              aria-label="Tree node label"
              value={this.props.node.label}
              onChange={(title) =>
                this.props.updateTitle(this.props.node, title)
              }
              fullWidth
              style={{ margin: "0 10px" }}
              placeholder="Enter a node label"
            />
          ) : (
            <ListItemText> {this.props.node.label}</ListItemText>
          )}
          <ListItemText />
          {this.props.node.type !== "root" && (
            <Tooltip title={"Delete"} aria-label={"Delete"}>
              <IconButton
                onClick={() =>
                  this.props.deleteNode(
                    this.props.parentNumber,
                    this.props.node.number
                  )
                }
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
          {this.props.node.type !== "root" && (
            <Tooltip title={"Edit note"} aria-label={"Edit note"}>
              <IconButton
                onClick={() => this.props.changeNotes(this.props.node)}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
          {((this.props.node.type === "answer" ||
            this.props.node.type === "root") &&
            this.props.node.children.length >= 1) ||
          this.props.node.type === "decision" ? null : (
            <Tooltip title={"Add child"} aria-label={"Add child"}>
              <IconButton
                onClick={() =>
                  this.props.addChild(
                    this.props.node.number,
                    this.props.node.type === "question" ? "answer" : "question"
                  )
                }
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
          )}
          {this.props.node.type !== "root" ? (
            <ButtonMenu title="node" ariaLabel={`node options`}>
              <MenuItem onClick={() => this.props.addAsCopy(this.props.node)}>
                Copy
              </MenuItem>
              <MenuItem
                onClick={() =>
                  this.props.cutNode(this.props.node, this.props.parentNumber)
                }
              >
                Cut
              </MenuItem>
              {this.props.copyNode &&
                this.props.copyNode.type !== this.props.node.type &&
                (this.props.node.type === "answer" &&
                this.props.node.children.length >= 1 ? null : (
                  <MenuItem
                    onClick={() => this.props.pasteNode(this.props.node)}
                  >
                    Paste
                  </MenuItem>
                ))}
            </ButtonMenu>
          ) : null}
          {/* {this.props.node.number} */}
        </ListItem>
        <Collapse in={this.state.open}>
          {this.props.node.children.map((child, idx) => (
            <TreeNode
              t={t}
              handleDrop={(node) => this.props.drop(node)}
              cutNode={this.props.cutNode}
              dragNode={this.props.dragNode}
              changeType={this.props.changeType}
              copyNode={this.props.copyNode}
              addAsCopy={this.props.addAsCopy}
              select
              pasteNode={this.props.pasteNode}
              changeNotes={this.props.changeNotes}
              selectNode={this.props.selectNode}
              selectedNode={this.props.selectedNode}
              count={this.props.count + 1}
              parentNumber={this.props.node.number}
              key={idx}
              node={child}
              addChild={this.props.addChild}
              updateTitle={this.props.updateTitle}
              deleteNode={this.props.deleteNode}
            />
          ))}
        </Collapse>
      </div>
    );
  }
  expand = () => {
    this.setState({ open: !this.state.open });
  };
  state = {
    open: true,
  };
}
// export default withStyles(styles)(DragSource('node', itemSource, collect)(DropTarget('node', targetSpec, targetCollect)(TreeNode)));
// export default withStyles(styles)(DragSource('item', itemSource, collect)(TreeNode));
// export default withStyles(styles)(DropTarget('item', {}, targetCollect)(TreeNode));
export default withStyles(styles)(withTranslation()(TreeNode));
